import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { CourtSystem } from '../court-system';
import { SharedRecording } from './SharedRecording';
export class SharedRecordingWithCourtSystem extends SharedRecording {
}
__decorate([
    Type(() => CourtSystem),
    __metadata("design:type", CourtSystem
    /**
     * To display the Live badge on the shared recordings list
     */
    )
], SharedRecordingWithCourtSystem.prototype, "courtSystem", void 0);
